import { Outlet } from '@remix-run/react';
import { SideOver } from '../../components';
import { elementsColors } from '../../../util';
import { LocalThemeContextProvider } from '../../context';
import { ElementDetailViewLayoutPageCommonProps } from '../shared';

export function BusinessTermElementDetailViewLayoutPage(props: ElementDetailViewLayoutPageCommonProps) {
  return (
    <SideOver {...props} className="!px-0">
      <LocalThemeContextProvider paletteSeedColor={elementsColors['Bt']}>
        <Outlet />
      </LocalThemeContextProvider>
    </SideOver>
  );
}
